// extracted by mini-css-extract-plugin
export default {"image":"N3-z","loaded":"O3-z"};